import { useState, useEffect, ReactElement } from "react";
import theme from "@/theme/theme";
import {
  AlpineIcon,
  BackpackIcon,
  CactusIcon,
  CampIcon,
  CheersIcon,
  DeerIcon,
  FarmIcon,
  FerrisIcon,
  GuitarIcon,
  KayakIcon,
  PalmIcon,
  ParachuteIcon,
  ParkIcon,
  ScubaMaskIcon,
  SignpostIcon,
  SunbedIcon,
  TelescopeIcon,
  TreesIcon,
  TropicalIcon,
  VolcanoIcon,
} from "@/components/Icon";
import styles from "./CategoryFilter.module.scss";

const useCategory = (categoryName: string | undefined) => {
  const [category, setCategory] = useState<
    { title: string; value: string; icon: ReactElement } | undefined
  >(undefined);

  useEffect(() => {
    const categoryIcon = [
      {
        title: "Tropical & Beachside",
        value: "tropical_and_beachside",
        icon: <TropicalIcon className={styles.cardIcon} variant="contained" />,
      },
      {
        title: "Cold Climate & Alpine",
        value: "cold_climate_and_alpine",
        icon: (
          <AlpineIcon
            className={styles.strokeIcon}
            variant="contained"
            stroke={theme.palette.common.grey[200]}
          />
        ),
      },
      {
        title: "Outback & Remote",
        value: "outback_and_remote",
        icon: (
          <CampIcon
            className={styles.strokeIcon}
            stroke={theme.palette.common.grey[200]}
            variant="contained"
          />
        ),
      },
      {
        title: "Rainforest & Eco Escape",
        value: "rainforest_and_eco_escape",
        icon: (
          <TreesIcon
            className={styles.strokeIcon}
            variant="contained"
            stroke={theme.palette.common.grey[200]}
          />
        ),
      },
      {
        title: "Countryside & Rural Escape",
        value: "countryside_and_rural_escape",
        icon: <FarmIcon className={styles.cardIcon} variant="contained" />,
      },
      {
        title: "Desert & Arid Adventure",
        value: "desert_and_arid_adventure",
        icon: <CactusIcon className={styles.cardIcon} variant="contained" />,
      },
      {
        title: "City Buzz",
        value: "city_buzz",
        icon: <FerrisIcon className={styles.cardIcon} variant="contained" />,
      },
      {
        title: "Island Life",
        value: "island_life",
        icon: <PalmIcon className={styles.cardIcon} variant="contained" />,
      },

      {
        title: "Backpacker Social Scene",
        value: "backpacker_social_scene",
        icon: <BackpackIcon className={styles.cardIcon} variant="contained" />,
      },
      {
        title: "Laidback & Slow Living",
        value: "laidback_and_slow_living",
        icon: (
          <SunbedIcon
            className={styles.strokeIcon}
            variant="contained"
            stroke={theme.palette.common.grey[200]}
          />
        ),
      },
      {
        title: "Adrenaline & Extreme Sports",
        value: "adrenaline_and_extreme_sports",
        icon: (
          <ParachuteIcon
            className={styles.cardIcon}
            variant="contained"
            viewBox="0 0 24 24"
          />
        ),
      },
      {
        title: "Foodie & Wine Regions",
        value: "foodie_and_wine_regions",
        icon: <CheersIcon className={styles.cardIcon} variant="contained" />,
      },
      {
        title: "Surf & Beach Culture",
        value: "surf_and_beach_culture",
        icon: (
          <KayakIcon
            className={styles.strokeIcon}
            variant="contained"
            stroke={theme.palette.common.grey[200]}
          />
        ),
      },
      {
        title: "Hiking & National Park",
        value: "hiking_and_national_parks",
        icon: (
          <ParkIcon
            className={styles.cardIcon}
            variant="contained"
            viewBox="0 0 24 24"
          />
        ),
      },
      {
        title: "Music & Art Hubs",
        value: "music_and_arts_hubs",
        icon: <GuitarIcon className={styles.cardIcon} variant="contained" />,
      },
      {
        title: "Wildlife & Conservation",
        value: "wildlife_and_conservation",
        icon: (
          <DeerIcon
            className={styles.strokeIcon}
            variant="contained"
            stroke={theme.palette.common.grey[200]}
          />
        ),
      },
      {
        title: "Diving & Marine Adventures",
        value: "diving_and_marine_adventures",
        icon: (
          <ScubaMaskIcon
            className={styles.strokeIcon}
            stroke={theme.palette.common.grey[200]}
            variant="contained"
          />
        ),
      },
      {
        title: "Cultural & Indigenous Experiences",
        value: "cultural_and_indigenous_experiences",
        icon: (
          <SignpostIcon
            className={styles.cardIcon}
            variant="contained"
            viewBox="0 0 24 24"
          />
        ),
      },
      {
        title: "Stargazing & Remote Tranquility",
        value: "stargazing_and_remote_tranquility",
        icon: (
          <TelescopeIcon
            className={styles.strokeIcon}
            variant="contained"
            stroke={theme.palette.common.grey[200]}
          />
        ),
      },
      {
        title: "Volcanic & Geothermal Wonders",
        value: "volcanic_and_geothermal_wonders",
        icon: <VolcanoIcon className={styles.cardIcon} variant="contained" />,
      },
    ];
    const currentCategory = categoryIcon.find(
      (each) => each.value === categoryName
    );
    setCategory(currentCategory);
  }, [categoryName]);

  return category;
};

export default useCategory;
